// extracted by mini-css-extract-plugin
module.exports = {"image":"_3qk-iM","text":"_5qXa4V"};